import httpClient from "./httpClient";

export default {
  async getNotifications() {
    const response = await httpClient.get("/notifications");
    return response.data;
  },

  async markAsRead(notificationId) {
    const response = await httpClient.put(`/notifications/${notificationId}`);
    return response.data;
  },

  async clearAll() {
    const response = await httpClient.delete(`/notifications`);
    return response.data;
  }
};
